<div class="huddle-action-edit-panel" [class.show]="showEditModal">
    <div class="huddle-action-edit-modal">
      <div class="action-edit-modal-header">
        <div class="modal-header-text">Action plans</div>
        <button class="modal-header-close-btn" (click)="closeEditModal()">
            <img src="assets/images/close.svg">
        </button>
      </div>
      <div class="action-edit-modal-body" id="action-edit-modal-body">
        <div class="huddle-action-field-container" *ngIf="isDataPrepared" id="huddle_edit_action_container">
          <div class="huddle-action-field-row" *ngFor="let field of columnsToEdit">
            <div class="huddle-action-field-header">
              {{field.title || field.name}}
            </div>
            <div class="huddle-action-field-value-container">
              <div class="label-field" *ngIf="field.is_cell_modify != true">{{dataToEdit[field.field_id]}}</div>
              <div class="label-field" *ngIf="field.is_cell_modify == true && field.elementType == 'label'">{{dataToEdit[field.field_id]}}</div>
              <div class="value-field" *ngIf="field.is_cell_modify == true  && field.elementType != 'label'">
                  <!-- please add new componenet heare when required -->
                   <!-- {{field|json}} -->
                  <app-ltms-datetime-picker *ngIf="field.elementType == 'date-picker'" [type]="field.data_type" [value]="dataToEdit[field.field_id]" (change)="updateValue($event,field)"></app-ltms-datetime-picker>
                  <app-litmus-dropdown *ngIf="field.elementType == 'list' && !field?.datasource?.options?.isAjax" [props]="field.props" [selectedOption]="field.selectedOption" (change)="updateValue($event,field)" ></app-litmus-dropdown>
                  <app-litmus-search *ngIf="field.elementType == 'list' && field?.datasource?.options?.isAjax" [props]="field.props" [selectedOption]="field.selectedOption" (change)="updateValue($event,field)"></app-litmus-search>
                  <litmus-input *ngIf="field.elementType == 'input'" [type]="field.type" [value]="dataToEdit[field.field_id]" (input)="updateValue($event,field)"></litmus-input>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-field-loader"  *ngIf="!isDataPrepared">
          <app-ltms-loader></app-ltms-loader>
        </div>
      </div>
      <div class="action-edit-modal-footer" [class.shadow]="isScrollEnabled()">
        <div class="footer-buttons">
          <button class="cancel-btn" (click)="cancel()">Cancel</button>
          <button class="apply-btn" [disabled]="!enableUpdateButton()"  (click)="updateData()">Update</button>
        </div>
      </div>
    </div>
  </div>